import request from '@/config/axios'

export interface AgentLevelDepositConfigVO {
  id?: number
  level: number
  /** 保证金（分） */
  depositAmount: number
  remark?: string
  updateTime?: string
}

export const getLevelDepositConfigList = () =>
  request.get<AgentLevelDepositConfigVO[]>({ url: '/agent/level-deposit-config/list' })

export const getLevelDepositConfig = (id: number) =>
  request.get<AgentLevelDepositConfigVO>({ url: '/agent/level-deposit-config/get', params: { id } })

export const createLevelDepositConfig = (data: {
  level: number
  depositAmount: number
  remark?: string
}) => request.post({ url: '/agent/level-deposit-config/create', data })

export const updateLevelDepositConfig = (data: {
  level: number
  depositAmount: number
  remark?: string
}) => request.put({ url: '/agent/level-deposit-config/update', data })

export const saveLevelDepositConfig = (data: {
  level: number
  depositAmount: number
  remark?: string
}) => request.put({ url: '/agent/level-deposit-config/save', data })

export const deleteLevelDepositConfig = (id: number) =>
  request.delete({ url: '/agent/level-deposit-config/delete', params: { id } })
